// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2ZxKp","title":"FrontImage_title__2RTRH"};